(function () {
    'use strict';

    angular
        .module('app')
        .directive('dataCard', dataCard);

    dataCard.$inject = [];

    function dataCard() {
        // Usage:
        //     <datacard></datacard>
        // Creates:
        // 
        var directive = {
            link: link,
            scope: {
                selectedRecord: '=',
                gridRecords: '=',
                showCard: '=',
                onHide: '&',
                height: '=',
                recordChanged: '='
            },
            restrict: 'EA',
            templateUrl: 'app/datacard/templates/datacard.html',
            controller: 'dataCard',
            controllerAs: 'vm'
        };
        return directive;

        function link(scope, element, attrs) {

            

        }
    }
})();